import { generateOneLinkURL } from "../../utils/oneLinkGenerator";

export default function getCtaUrl({ webContext, product, isMobile }) {
  const desktopUrl = `/discover/our-apps/?campaign=pdp-app-download&deepLink=asos://prd%3Fiid=${product.id}&media=button`;

  return isMobile ? generateOneLinkURL(webContext, product) : desktopUrl;
}
